import { render, staticRenderFns } from "./username.vue?vue&type=template&id=707316bf"
import script from "./username.vue?vue&type=script&lang=js"
export * from "./username.vue?vue&type=script&lang=js"
import style0 from "./username.vue?vue&type=style&index=0&id=707316bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports